'use strict';

const rem = () => parseFloat(getComputedStyle(document.documentElement).fontSize); // 1rem in px

const breakpoints = {
    xs: 0,
    sm: 36, // 576px
    md: 48, // 768px
    lg: 62, // 992px
    xl: 75, // 1200px
    xxl: 87.5, // 1400px
    xxxl: 120, // 1920px

    up: device => window.innerWidth >= breakpoints[device] * rem(),
    down: device => window.innerWidth < breakpoints[device] * rem()
};

module.exports = breakpoints;
